import React, { useEffect, useRef } from 'react';
import { useGlobalContext } from '../../js/context';
import Button from '../button/Button.jsx';
import { gtmTracking, gtm4Tracking } from '../../js/helpers';
import './Header.scss';

const Header = () => {
	const {
		page,
		singleProduct,
		products,
		isMobile,
		isSafari,
		changePageHandler,
		nextProductHandler,
		prevProductHandler,
		isFullScreen,
		fullScreenHandler,
	} = useGlobalContext();
	const allComponentsBtnRef = useRef();

	const classDetailPage =
		page && page === 'element_page' ? 'tos-header--details' : '';

	const allComponentBtnFocusHandler = (e) => {
		if (e.keyCode === 97 || e.code === 'KeyA') {
			allComponentsBtnRef.current.focus();
		}
	};

	useEffect(() => {
		if (page && page === 'element_page') {
			document.addEventListener('keypress', allComponentBtnFocusHandler);
		}
		return () => {
			document.removeEventListener('keypress', allComponentBtnFocusHandler);
		};
	}, [page]);

	return (
		<div className={`tos-header ${classDetailPage}`}>
			{page && page === 'element_page' && (
				<>
					<div className='tos-header__buttons'>
						<Button
							title='previous'
							small
							arrowPosition='left'
							onClick={prevProductHandler}
						>
							<svg
								width='16'
								height='16'
								viewBox='0 0 16 16'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M13 8L3.5 8M3.5 8C3.5 8 6.13317 10.6332 7.5 12M3.5 8C3.5 8 6.13317 5.36683 7.5 4'
									stroke='white'
								/>
							</svg>
						</Button>
						<span className='tos-header__pagination'>
							<strong>{singleProduct?.id + 1}</strong> / {products.length}
						</span>

						<Button
							title='next'
							small
							arrowPosition='right'
							onClick={nextProductHandler}
						>
							<svg
								width='16'
								height='17'
								viewBox='0 0 16 17'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'
							>
								<path
									d='M3 8.5H12.5M12.5 8.5C12.5 8.5 9.86683 5.86683 8.5 4.5M12.5 8.5C12.5 8.5 9.86683 11.1332 8.5 12.5'
									stroke='white'
								/>
							</svg>
						</Button>
					</div>
					<Button
						title='ALL CONSTITUENTS'
						small
						hideTextOnMobile
						arrowPosition='right'
						onClick={() => {
							changePageHandler('menu_page');
							gtm4Tracking({event: 'GA4_event_c_tfs_all_constituents_click'});
							gtmTracking('navigation', 'all constituents');
						}}
						ref={allComponentsBtnRef}
					>
						<svg
							width='18'
							height='18'
							viewBox='0 0 20 20'
							fill='none'
							xmlns='http://www.w3.org/2000/svg'
						>
							<path
								d='M7.24635 0.000103464H1.15933C0.519001 0.000103464 0 0.519312 0 1.15943V7.24645C0 7.88678 0.519208 8.40578 1.15933 8.40578H7.24635C7.88668 8.40578 8.40568 7.88657 8.40568 7.24645V1.15943C8.40568 0.519105 7.88647 0.000103464 7.24635 0.000103464ZM7.24635 7.24656H1.15933V1.15954H7.24635V7.24656ZM7.24635 11.3045H1.15933C0.519001 11.3045 0 11.8237 0 12.4638V18.5508C0 19.1911 0.519208 19.7101 1.15933 19.7101H7.24635C7.88668 19.7101 8.40568 19.1909 8.40568 18.5508V12.4638C8.40568 11.8237 7.88647 11.3045 7.24635 11.3045ZM7.24635 18.5509H1.15933V12.4639H7.24635V18.5509ZM18.8407 0H12.7537C12.1133 0 11.5943 0.519208 11.5943 1.15933V7.24635C11.5943 7.88668 12.1135 8.40568 12.7537 8.40568H18.8407C19.481 8.40568 20 7.88647 20 7.24635V1.15933C20 0.519001 19.4808 0 18.8407 0ZM18.8407 7.24645H12.7537V1.15943H18.8407V7.24645ZM18.8407 11.3044H12.7537C12.1133 11.3044 11.5943 11.8236 11.5943 12.4637V18.5507C11.5943 19.191 12.1135 19.71 12.7537 19.71H18.8407C19.481 19.71 20 19.1908 20 18.5507V12.4637C20 11.8236 19.4808 11.3044 18.8407 11.3044ZM18.8407 18.5508H12.7537V12.4638H18.8407V18.5508Z'
								fill='white'
							/>
						</svg>
					</Button>
				</>
			)}

			{((page && page !== 'home_page') || isMobile) && (
				<Button
					className={`tos-header__button ${
						isSafari && isMobile ? 'tos-header__button--safari-mobile' : ''
					}`}
					title={isFullScreen ? 'Exit Fullscreen' : 'Fullscreen'}
					small
					hideTextOnMobile
					arrowPosition='right'
					onClick={() => fullScreenHandler()}
				>
					<svg
						width='20'
						height='20'
						viewBox='0 0 20 20'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
					>
						<path d='M2 8V2H8' stroke='white' />
						<path d='M12 2L18 2L18 8' stroke='white' />
						<path d='M8 18L2 18L2 12' stroke='white' />
						<path d='M18 12L18 18L12 18' stroke='white' />
					</svg>
				</Button>
			)}
		</div>
	);
};

export default Header;
